<template>
  <power-wrapper :CurrRole="CurrRole">
    <div class="distributorList" v-show="pages.trial && currentPage === pages.trial.name">
      <div class="topLeft">
        <h3>AI外呼</h3>
      </div>
      <el-form :inline="true" :model="listQuery" label-width="100px">
        <el-form-item label="userID">
          <el-input
            type="number"
            v-model="listQuery.userId"
            placeholder="输入userID查询"
            class="orderStyle numrule"
            autocomplete="on"
          />
        </el-form-item>
        <el-form-item label="回传时间">
          <el-date-picker
            v-model="createTime"
            value-format="timestamp"
            type="daterange"
            :picker-options="pickerOptions"
            @blur="enableChoose"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width:235px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="失败原因">
          <el-select v-model="listQuery.failStatus" filterable placeholder="请选择失败原因">
            <el-option label="全部失败原因" :value="null" />
            <el-option
              v-for="item in failStatusList"
              :key="item.status"
              :label="item.description"
              :value="item.status"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="推广链接ID">
          <el-input v-model="listQuery.linkCode" placeholder="输入推广链接ID查询" class="orderStyle" />
        </el-form-item>
        <el-form-item label="订单状态">
          <el-select v-model="listQuery.orderStatus" filterable placeholder="请选择订单状态">
            <el-option label="全部订单状态" :value="null" />
            <el-option
              v-for="(item, i) in orderStatus"
              :key="i"
              :label="item"
              :value="i"
            />
          </el-select>
        </el-form-item>
        <el-button class="filter-item" type="primary" @click="handleSearch">查询</el-button>
        <el-button :class="{'btnCreate': true, btn: true}" type="primary" icon="el-icon-download" @click="exportExcel">下载表格</el-button>
      </el-form>
      <el-table v-loading="listLoading" :data="list" :empty-text="emptyText" border fit highlight-current-row style="width: 100%" :header-cell-style="tableHeader">
        <el-table-column label="回传时间" align="center" width="160">
          <template slot-scope="{row}">
            <span>{{ row.ctime ? timestampToDate(row.ctime) : '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单号" align="center" width="160">
          <template slot-scope="{row}">
            <span>{{ row.orderNumber || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单状态" align="center" min-width="90">
          <template slot-scope="{row}">
            <span>{{ row.orderStatus === 1 ? '成功' : '失败' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="userID" align="center" min-width="100">
          <template slot-scope="{row}">
            <span>{{ row.userId }}</span>
          </template>
        </el-table-column>
        <el-table-column label="推广链接ID" align="center" min-width="120">
          <template slot-scope="{row}">
            <span>{{ row.linkCode || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="年级标签" align="center" min-width="115">
          <template slot-scope="{row}">
            <span>{{ row.grade || '' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="上课设备" align="center" min-width="115">
          <template slot-scope="{row}">
            <span>{{ row.device || '' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单失败原因" align="center" min-width="100">
          <template slot-scope="{row}">
            <span>{{ getFailStatus(row.failStatus) }}</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="total>0"
        :total="total"
        :page.sync="listQuery.pageNum"
        :limit.sync="listQuery.pageSize"
        @pagination="getList"
      />
    </div>
  </power-wrapper>
</template>

<script>
import Cookie from 'js-cookie';
import { exportExcel } from "@/services/downExcel";
import Pagination from "@/components/Pagination/index";
import { getAIOrderList, getFailStatusList } from "@/services/order";
import PowerWrapper from "@/components/PowerWrapper";
import { timestampToDate, delUndefined, timestampToDateTotal } from "@/utils/utils";

const orderStatus = {
  0: '失败',
  1: '成功',
}

export default {
  name: "order",
  components: {
    Pagination,
    PowerWrapper,
  },
  data() {
    return {
      CurrRole: "order",
      list: [],
      currentPage: 'trial',
      pages: {
        trial: {
          name: 'trial',
          text: '体验课订单'
        }
      },
      orderStatus,
      emptyText: '暂无数据',
      listQuery: {
        pageNum: 1,
        pageSize: 10,
        userId: '',
        linkCode: '',
        failStatus: '',
        orderSource: 2,
        orderStatus: null,
      },
      createTime: [new Date().getTime() - 3600 * 1000 * 24 * 30, new Date().getTime()],
      pickerMinDate: "", // 第一次选中的时间
      pickerOptions: {
        shortcuts: [
          {
            text: "今日",
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().setHours(0, 0, 0, 0));
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "昨日",
            onClick(picker) {
              const start = new Date();
              start.setTime(start.getTime() - 24 * 60 * 60 * 1000);
              start.setHours(0, 0, 0, 0);
              const end = new Date();
              end.setTime(end.getTime() - 24 * 60 * 60 * 1000);
              end.setHours(23, 59, 59, 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              const end = new Date();
              const week = end.getDay();
              const millisecond = 1000 * 60 * 60 * 24;
              const minusDay = week !== 0 ? week - 1 : 6;
              const monday = new Date(end.getTime() - minusDay * millisecond);
              const start = new Date(monday);
              start.setHours(0, 0, 0, 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "上周",
            onClick(picker) {
              // 上周开始时间
              const starta = new Date();
              var first = starta.getDate() - starta.getDay() - 6;
              var startDate = new Date(starta.setDate(first));
              const start = new Date(startDate);
              start.setHours(0, 0, 0, 0);
              //  上周结束时间
              var currentDate = new Date();
              var firsts = currentDate.getDate() - currentDate.getDay() - 6;
              var last = firsts + 6;
              var endDate = new Date(currentDate.setDate(last));
              const end = new Date(endDate);
              end.setHours(23, 59, 59, 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本月",
            onClick(picker) {
              const currentDate = new Date();
              const currentMonth = currentDate.getMonth();
              const currentYear = currentDate.getFullYear();
              const start = new Date(currentYear, currentMonth, 1);
              const end = new Date();
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "上月",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              const m = start.getMonth() - 1;
              start.setDate(1);
              start.setMonth(m);
              end.setDate(0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ],
        onPick: obj => {
          this.pickerMinDate = new Date(obj.minDate).getTime();
        },
        // disabledDate: time => {
        //   if (this.pickerMinDate) {
        //     const day1 = 93 * 24 * 3600 * 1000;
        //     const maxTime = this.pickerMinDate + day1;
        //     const minTime = this.pickerMinDate - day1;
        //     return time.getTime() > maxTime || time.getTime() < minTime;
        //   }
        // }
      },
      total: 1,
      listLoading: false,
      failStatusList: [],
      loading: null
    };
  },
  computed: {
    tableHeader() {
      return () => {
        return { 'background-color': '#f5f5f5' }
      }
    }
  },
  created() {
    this.getList()
    // 统计接口
    this.getFailStatusList()
  },
  watch: {
  },
  mounted() {
  },
  methods: {
    exportExcel() {
      const { listQuery, createTime, total } = this;
      const params = {
        ...listQuery,
        pageSize: total || 1000,
        ctimeBeginStr: createTime && timestampToDate(createTime[0]),
        ctimeEndStr: createTime && timestampToDate(createTime[1]),
      }
      const apiPath = 'agent-manual-orders/download';
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.6)'
      });
      console.log('createTime', createTime, delUndefined(params))
      exportExcel({
        params: delUndefined(params),
        apiPath
      }).then(res => {
        if (res.data && res.data.errCode && Number(res.data.errCode) > 0) {
          this.loading.close();
          this.$message({ type: 'error', message: `导出失败 ${res.data.errMsg || ''}` })
          return
        }
        if (res.data && res.data.type && res.data.type === 'application/json') {
          this.loading.close();
          const fr = new FileReader()
          fr.onload = (e) => {
            const result = e && e.target && e.target.result ? JSON.parse(e.target.result) : {}
            this.$message({ type: 'error', message: `导出失败 ${result.errMsg || ''}` })
          }
          return fr.readAsText(res.data)
        }
        if (res) {
          setTimeout(() => {
            this.loading.close();
          }, 1000)
          const blob = new Blob([res]);
          const downloadElement = document.createElement('a');
          const objectUrl = window.URL.createObjectURL(blob); // 创建下载的链接
          downloadElement.href = objectUrl;
          downloadElement.download = 'AI外呼订单页.csv'; // 下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); // 点击下载
          document.body.removeChild(downloadElement); // 下载完成移除元素
          window.URL.revokeObjectURL(objectUrl);
        }
      });
    },
    enableChoose() {
      this.pickerMinDate = null
    },
    handleStatus(value) {
      return value ? value === 'UNPAID' ? '未支付' : value === 'PAID' ? '已支付' : value === 'REFUND' ? '已退费' : '' : null
    },
    timestampToDate,
    timestampToDateTotal,
    getFailStatusList() {
      getFailStatusList().then(res => {
        const { data } = res.data || {};
        if (data && res.data.errCode === 0) {
          this.failStatusList = data;
        } else {
          this.failStatusList = [];
        }
      });
    },
    getList(btnName) {
      this.listLoading = true;
      const { listQuery, createTime } = this;
      const params = {
        ...listQuery,
        pageNum: btnName === 'search' ? 1 : this.listQuery.pageNum,
        ctimeBegin: createTime && createTime[0],
        ctimeEnd: createTime && createTime[1],
      }
      getAIOrderList({
        type: 'POST',
        params: delUndefined(params)
      }).then((res = {}) => {
        const { errCode, errMsg, data } = res.data || {};
        const { list, total } = data || {};
        if (errCode === 0 && Array.isArray(list) && list.length > 0) {
          this.listLoading = false;
          this.list = list;
          this.total = total;
          if (btnName === 'search') {
            this.listQuery.pageNum = 1;
          }
        } else if (errCode === 1016) {
          this.$message({ type: 'error', message: '登录时效已过期，请重新登录' })
          Cookie.remove('staffToken')
          setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 3000)
        } else {
          this.emptyText = errMsg && errMsg !== 'success' ? errMsg : '暂无数据';
          this.listLoading = false;
          this.list = [];
          this.total = 0;
        }
      });
    },
    handleSearch() {
      this.getList('search');
    },
    getFailStatus(key) {
      const failStatus = this.failStatusList.find(item => item.status === key);
      return failStatus ? failStatus.description : '--';
    }
  }
};
</script>

<style lang="less" scoped>
@import '../../styles/common.less';
.icon-question{
  cursor: pointer;
}
</style>
